module.exports = __webpack_public_path__ + "static/main-df933d8391180d11db1e116f36229f67.png";